(() => {
  const initialize = () => {
    const root = document.querySelector('[data-waiiqi-concierge]');
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const launcher = root.querySelector('[data-concierge-open]');
    const backdrop = root.querySelector('[data-concierge-backdrop]');
    const dialog = root.querySelector('[data-concierge-dialog]');
    const closeButton = root.querySelector('[data-concierge-close]');
    const panel = root.querySelector('[data-concierge-panel]');
    const footer = root.querySelector('[data-concierge-footer]');
    const backButton = root.querySelector('[data-concierge-back]');
    const restartButton = root.querySelector('[data-concierge-restart]');
    const productsNode = root.querySelector('[data-concierge-products]');
    const stringsNode = root.querySelector('[data-concierge-strings]');
    const savedCount = root.querySelector('[data-concierge-saved-count]');
    const dialogTitle = root.querySelector('#WaiiqiConciergeTitle');
    const dialogCopy = root.querySelector('.waiiqi-concierge__header p');
    const originalTitle = dialogTitle.textContent;
    const originalCopy = dialogCopy.textContent;
    const setSavedPresentation = enabled => {
      root.toggleAttribute('data-saved-view', enabled);
      root.querySelector('.waiiqi-concierge__message').hidden = enabled;
      dialogTitle.textContent = enabled ? strings.savedJourney : originalTitle;
      dialogCopy.textContent = enabled ? (storageAvailable ? strings.savedPrivacy : strings.storageUnavailable) : originalCopy;
    };

    let payload = {};
    let strings = {};
    try {
      payload = JSON.parse(productsNode.textContent);
      strings = JSON.parse(stringsNode.textContent);
    } catch (error) {
      launcher.hidden = true;
      return;
    }

    const products = (payload.products || []).map((item) => ({
      ...item,
      materials: Array.isArray(item.materials) ? item.materials : [],
      fit: item.fit || '',
      giftIntent: item.giftIntent || '',
      variantId: item.variantId ? String(item.variantId) : '',
      variantAvailable: item.variantAvailable === true,
      singleVariant: item.singleVariant === true
    }));
    const physical = products.filter((item) => item.available && !item.giftCard);
    const digital = products.find((item) => item.available && item.giftCard);
    const current = payload.current || null;
    const productByHandle = new Map(products.map((item) => [item.handle, item]));
    const sortedByPrice = [...physical].sort((a, b) => a.price - b.price);
    const storageKey = 'waiiqi_my_wave_v1';
    const avatarKey = 'waiiqi_my_wave_avatar_v1';
    const avatars = {wave: '≈', sun: '☼', shell: '◉'};
    let avatar = 'wave';
    let storageAvailable = true;
    try { const value = localStorage.getItem(avatarKey); if (Object.hasOwn(avatars, value)) avatar = value; } catch { storageAvailable = false; }
    const loadSavedHandles = () => {
      try {
        const stored = JSON.parse(window.localStorage.getItem(storageKey) || '[]');
        return [...new Set(Array.isArray(stored) ? stored : [])]
          .filter((handle) => productByHandle.has(handle))
          .slice(0, 12);
      } catch (error) {
        return [];
      }
    };

    const state = { journey: null, step: 0, answers: {}, history: [] };
    let lastFocused = null;
    let closeTimer = null;
    let openFrame = null;
    let pendingQuickAdd = null;
    let savedHandles = loadSavedHandles();

    const escapeHtml = (value) => String(value ?? '').replace(/[&<>"']/g, (character) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#039;'
    })[character]);

    const safeUrl = (value) => {
      try {
        const url = new URL(value, window.location.origin);
        if (url.origin !== window.location.origin) return '#';
        return escapeHtml(`${url.pathname}${url.search}${url.hash}`);
      } catch (error) {
        return '#';
      }
    };

    // Progressive handoff to the installed Shopify Inbox control. If Shopify
    // changes that control, keep its native entry and the contact-page fallback.
    const nativeChatControl = () => {
      const shadow = document.querySelector('shopify-chat')?.shadowRoot;
      return shadow?.querySelector('button[part~="activator"]') ||
        shadow?.querySelector('shopify-agent-runtime')?.shadowRoot?.querySelector('button[part~="activator"]');
    };
    let chatWasOpen = false;
    const chatRoots = new WeakSet();
    const syncNativeChat = () => {
      const control = nativeChatControl();
      const isOpen = control?.getAttribute('aria-expanded') === 'true';
      document.documentElement.classList.toggle('waiiqi-chat-integrated', !!control);
      document.documentElement.classList.toggle('waiiqi-native-chat-open', isOpen);
      if (chatWasOpen && !isOpen) launcher.focus({preventScroll: true});
      chatWasOpen = isOpen;
      const shadow = document.querySelector('shopify-chat')?.shadowRoot;
      [shadow, shadow?.querySelector('shopify-agent-runtime')?.shadowRoot].filter(Boolean).forEach((chatRoot) => {
        if (chatRoots.has(chatRoot)) return;
        chatRoots.add(chatRoot);
        new MutationObserver(syncNativeChat).observe(chatRoot, {childList: true, subtree: true, attributes: true, attributeFilter: ['aria-expanded']});
      });
    };

    const format = (template, values = {}) => Object.entries(values).reduce(
      (output, [key, value]) => output.replaceAll(`__${key}__`, String(value)),
      String(template || '')
    );

    const emit = (event, detail = {}) => {
      const namespacedEvent = `waiiqi:${event}`;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event, component: 'waiiqi_smart_concierge', locale: root.dataset.locale, ...detail });
      document.dispatchEvent(new CustomEvent(namespacedEvent, { detail }));
      if (window.Shopify?.analytics?.publish) {
        Promise.resolve(window.Shopify.analytics.publish(namespacedEvent, { locale: root.dataset.locale, ...detail })).catch(() => {});
      }
    };

    const updateSavedCount = () => {
      if (savedCount) {
        savedCount.textContent = String(savedHandles.length);
        savedCount.hidden = savedHandles.length === 0;
      }
      document.querySelectorAll('[data-waiiqi-saved-count]').forEach((count) => {
        count.textContent = String(savedHandles.length);
      });
      document.querySelectorAll('[data-waiiqi-save-piece]').forEach((button) => {
        const available = productByHandle.has(button.dataset.waiiqiSavePiece);
        const actions = button.closest('[data-waiiqi-saved-actions]');
        if (actions) actions.hidden = !available;
        button.setAttribute('aria-pressed', String(savedHandles.includes(button.dataset.waiiqiSavePiece)));
        const label = button.querySelector('[data-waiiqi-save-label]');
        if (label) label.textContent = savedHandles.includes(button.dataset.waiiqiSavePiece) ? strings.saved : strings.saveCurrent;
      });
      document.querySelectorAll('[data-waiiqi-avatar]').forEach(node => { node.textContent = avatars[avatar]; });
      if (!storageAvailable) document.querySelectorAll('[data-waiiqi-storage-note]').forEach(node => { node.textContent = strings.storageUnavailable; });
      document.querySelectorAll('[data-waiiqi-saved-menu]').forEach((menu) => { menu.hidden = false; });
    };

    const persistSavedHandles = () => {
      try {
        window.localStorage.setItem(storageKey, JSON.stringify(savedHandles));
      } catch (error) {
        storageAvailable = false;
      }
      updateSavedCount();
    };

    const saveHandle = (handle, source) => {
      if (!productByHandle.has(handle) || savedHandles.includes(handle)) return false;
      savedHandles = [...savedHandles, handle].slice(-12);
      persistSavedHandles();
      emit('smart_concierge_piece_saved', { product_handle: handle, source, saved_count: savedHandles.length });
      return true;
    };

    const removeSavedHandle = (handle, source) => {
      if (!savedHandles.includes(handle)) return false;
      savedHandles = savedHandles.filter((savedHandle) => savedHandle !== handle);
      persistSavedHandles();
      emit('smart_concierge_piece_removed', { product_handle: handle, source, saved_count: savedHandles.length });
      return true;
    };

    const folded = (value) => String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase();
    const typeFor = (item) => /glasses|sunglasses|lunettes|gafas|brille|sonnenbrille|occhiali/.test(folded(item.fit)) ? 'eyewear' : 'bracelet';
    const normalizedIntent = (value) => {
      const intent = folded(value);
      if (intent.includes('premium')) return 'premium';
      if (/adventure|aventure|aventura|abenteuer|avventura/.test(intent)) return 'adventure';
      if (/eyewear|lunettes|gafas|brillen|occhiali/.test(intent)) return 'eyewear';
      if (/everyday|quotidien|cada dia|jeden tag|quotidiano/.test(intent)) return 'everyday';
      return intent.replace(' gift', '').trim();
    };
    const canonicalMaterial = (value) => {
      const material = folded(value);
      if (/pearl|perle|perla|susswasser/.test(material)) return 'Cultured freshwater pearl';
      if (/glass|verre|vidrio|glas|vetro|cristal|kristall|cristallo/.test(material)) return 'Glass or crystal';
      if (/natural fibre|fibre naturelle|fibra natural|naturfaser|fibra naturale/.test(material)) return 'Natural fibre';
      if (/cord|cordon|kordel|cordino/.test(material)) return 'Cord';
      if (/wood|bois|madera|holz|legno/.test(material)) return 'Wood';
      if (/metal|metall|metallo/.test(material)) return 'Metal';
      return value;
    };
    const materialMatches = (item, selected) => item.materials.some((value) => canonicalMaterial(value) === selected);
    const materialLabel = (value) => ({
      Cord: strings.cord,
      Wood: strings.wood,
      Metal: strings.metal,
      'Cultured freshwater pearl': strings.pearl
    })[value] || value;
    const localizedFit = (value) => {
      const fit = folded(value);
      const hasAnklet = /anklet option|option cheville|opcion de tobillera|fusskettchen-option|opzione cavigliera/.test(fit);
      const hasSmall = /small to large|fins a larges|pequenas a grandes|schmale bis breite|piccoli e grandi/.test(fit);
      const hasMedium = /medium to large|moyens a larges|medianas a grandes|mittlere bis breite|medi e grandi/.test(fit);
      if (hasSmall && hasAnklet) return strings.fitSmallAnklet;
      if (hasMedium && hasAnklet) return strings.fitAnklet;
      if (hasSmall) return strings.fitSmall;
      if (hasMedium) return strings.fitMedium;
      if (/glasses|sunglasses|lunettes|gafas|brille|sonnenbrille|occhiali/.test(fit)) return strings.fitEyewear;
      if (/sizing guidance required|conseils de taille|orientacion de talla|grossenberatung|guida alla taglia/.test(fit)) return strings.fitGuidance;
      return value;
    };

    const stableHash = (value) => {
      let hash = 2166136261;
      for (const character of String(value || '')) {
        hash ^= character.charCodeAt(0);
        hash = Math.imul(hash, 16777619);
      }
      return hash >>> 0;
    };

    const emitChoice = (button, answer) => {
      const question = button.closest('[data-concierge-question]');
      if (!question) return;
      question.querySelectorAll('[data-concierge-choice]').forEach((item) => item.setAttribute('aria-pressed', 'false'));
      button.setAttribute('aria-pressed', 'true');
      state.history.push({ key: answer.key, value: answer.value, label: answer.label });
      state.answers[answer.key] = answer.value;
      emit('smart_concierge_answered', {
        journey: state.journey,
        step: answer.key,
        value: answer.value
      });
      state.step += 1;
      window.setTimeout(renderJourneyStep, 140);
    };

    const option = ({ value, label, icon = '✦', note = '' }) => `
      <button class="waiiqi-concierge__choice" type="button" data-concierge-choice="${escapeHtml(value)}" aria-pressed="false">
        <span class="waiiqi-concierge__choice-icon" aria-hidden="true">${escapeHtml(icon)}</span>
        <span><strong>${escapeHtml(label)}</strong>${note ? `<small>${escapeHtml(note)}</small>` : ''}</span>
      </button>
    `;

    const renderQuestion = (step) => {
      panel.innerHTML = `
        <div class="waiiqi-concierge__question" data-concierge-question>
          <p class="waiiqi-concierge__step-count">${state.step + 1} / ${stepsForJourney().length}</p>
          <h3>${escapeHtml(step.question)}</h3>
          <div class="waiiqi-concierge__choices">
            ${step.options.map(option).join('')}
          </div>
        </div>
      `;
      panel.querySelectorAll('[data-concierge-choice]').forEach((button) => {
        button.addEventListener('click', () => {
          const selected = step.options.find((item) => item.value === button.dataset.conciergeChoice);
          if (selected) emitChoice(button, { key: step.key, value: selected.value, label: selected.label });
        });
      });
      footer.hidden = false;
      backButton.disabled = state.step === 0;
      panel.querySelector('h3')?.focus?.();
    };

    const budgetOptions = () => {
      const productAt = (fraction) => sortedByPrice[Math.min(sortedByPrice.length - 1, Math.max(0, Math.round((sortedByPrice.length - 1) * fraction)))];
      return [productAt(0.34), productAt(0.68)]
        .filter(Boolean)
        .filter((item, index, list) => list.findIndex((candidate) => candidate.price === item.price) === index)
        .map((item) => ({ value: String(item.price), label: format(strings.upTo, { PRICE: item.priceFormatted }), icon: '€' }))
        .concat([{ value: 'any', label: strings.anyBudget, icon: '✦' }]);
    };

    const stepsForJourney = () => {
      const typeStep = {
        key: 'type',
        question: strings.typeQuestion,
        options: [
          { value: 'bracelet', label: strings.bracelet, icon: '○' },
          { value: 'eyewear', label: strings.eyewear, icon: '∞' },
          { value: 'any', label: strings.either, icon: '✦' }
        ]
      };
      const intentStep = {
        key: 'intent',
        question: strings.intentQuestion,
        options: [
          { value: 'everyday', label: strings.everyday, icon: '☼' },
          { value: 'adventure', label: strings.adventure, icon: '≈' },
          { value: 'premium', label: strings.premium, icon: '◇' },
          { value: 'any', label: strings.anyIntent, icon: '✦' }
        ]
      };
      const materialStep = {
        key: 'material',
        question: strings.materialQuestion,
        options: [
          { value: 'Cord', label: strings.cord, icon: '〰' },
          { value: 'Wood', label: strings.wood, icon: '▣' },
          { value: 'Metal', label: strings.metal, icon: '△' },
          { value: 'Cultured freshwater pearl', label: strings.pearl, icon: '●' },
          { value: 'any', label: strings.noMaterial, icon: '✦' }
        ]
      };
      const budgetStep = { key: 'budget', question: strings.budgetQuestion, options: budgetOptions() };
      return state.journey === 'gift'
        ? [intentStep, typeStep, materialStep, budgetStep]
        : [typeStep, intentStep, materialStep, budgetStep];
    };

    const reasonsFor = (item) => {
      const reasons = [];
      if (state.answers.type !== 'any' && typeFor(item) === state.answers.type) reasons.push(strings.reasonType);
      if (state.answers.intent !== 'any' && normalizedIntent(item.giftIntent) === state.answers.intent) reasons.push(strings.reasonIntent);
      if (state.answers.material !== 'any' && materialMatches(item, state.answers.material)) reasons.push(strings.reasonMaterial);
      if (state.answers.budget !== 'any' && item.price <= Number(state.answers.budget)) reasons.push(strings.reasonBudget);
      return reasons.length ? format(strings.reasonSentence, { REASONS: reasons.slice(0, 3).join(', ') }) : strings.reasonDefault;
    };

    const rankProducts = () => {
      const budget = state.answers.budget === 'any' ? null : Number(state.answers.budget);
      const signature = Object.values(state.answers).join('|');
      const typeCandidates = physical.filter((item) => state.answers.type === 'any' || typeFor(item) === state.answers.type);
      const score = (item) => {
        let points = 10;
        if (state.answers.type !== 'any' && typeFor(item) === state.answers.type) points += 30;
        if (state.answers.intent !== 'any' && normalizedIntent(item.giftIntent) === state.answers.intent) points += 50;
        if (state.answers.material !== 'any' && materialMatches(item, state.answers.material)) points += 35;
        if (budget !== null && item.price <= budget) points += 12;
        return { ...item, score: points, tieBreak: stableHash(`${signature}|${item.id}`) };
      };
      const sort = (a, b) => b.score - a.score || a.tieBreak - b.tieBreak || a.price - b.price;
      let candidates = typeCandidates.filter((item) => budget === null || item.price <= budget).map(score).sort(sort);
      let relaxed = false;
      if (!candidates.length) {
        candidates = typeCandidates.map(score).sort(sort);
        relaxed = true;
      }
      return { results: candidates.slice(0, 3), relaxed };
    };

    const productCard = (item, index, context = 'match') => {
      const facts = [];
      if (!item.giftCard && item.materials.length) facts.push(`${strings.materials}: ${item.materials.map(materialLabel).join(' · ')}`);
      if (!item.giftCard && item.fit) facts.push(`${strings.fit}: ${localizedFit(item.fit)}`);
      const rank = context === 'compare' && index === 0
        ? strings.selection
        : index === 0
          ? strings.best
          : format(strings.alternative, { NUMBER: index });
      const reason = item.giftCard ? strings.digitalReason : context === 'compare' ? strings.reasonDefault : reasonsFor(item);
      const canQuickAdd = item.available && item.singleVariant && item.variantAvailable && item.variantId;
      const isSaved = savedHandles.includes(item.handle);
      const saveLabel = context === 'saved' ? strings.remove : isSaved ? strings.saved : strings.save;
      return `
        <article class="waiiqi-concierge__product" data-concierge-result-card data-product-handle="${escapeHtml(item.handle)}">
          ${item.image ? `<a class="waiiqi-concierge__product-media" href="${safeUrl(item.url)}" data-concierge-result-link data-position="${index + 1}"><img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.imageAlt || item.title)}" loading="lazy" width="720" height="720"></a>` : ''}
          <div class="waiiqi-concierge__product-copy">
            <span class="waiiqi-concierge__rank">${escapeHtml(rank)}</span>
            <h4><a href="${safeUrl(item.url)}" data-concierge-result-link data-position="${index + 1}">${escapeHtml(item.title)}</a></h4>
            <p>${escapeHtml(reason)}</p>
            ${facts.length ? `<p class="waiiqi-concierge__facts">${escapeHtml(facts.join(' · '))}</p>` : ''}
            <div class="waiiqi-concierge__product-action">
              <strong>${escapeHtml(item.priceFormatted)}</strong>
              <div class="waiiqi-concierge__product-buy">
                <button class="waiiqi-concierge__save" type="button" data-concierge-save data-product-handle="${escapeHtml(item.handle)}" data-context="${escapeHtml(context)}" aria-pressed="${isSaved ? 'true' : 'false'}">♡ ${escapeHtml(saveLabel)}</button>
                ${canQuickAdd ? `<add-to-cart class="button button--small" role="button" tabindex="0" data-variant-id="${escapeHtml(item.variantId)}" data-concierge-quick-add data-context="${escapeHtml(context)}" data-position="${index + 1}" data-product-handle="${escapeHtml(item.handle)}">${escapeHtml(strings.add)}</add-to-cart>` : ''}
                <a class="waiiqi-concierge__details-link" href="${safeUrl(item.url)}" data-concierge-result-link data-position="${index + 1}">${escapeHtml(strings.view)} →</a>
              </div>
            </div>
          </div>
        </article>
      `;
    };

    const bindResultLinks = (context, items) => {
      panel.querySelectorAll('[data-concierge-result-link]').forEach((link) => {
        link.addEventListener('click', () => {
          const card = link.closest('[data-concierge-result-card]');
          emit('smart_concierge_result_clicked', {
            journey: context,
            product_handle: card?.dataset.productHandle || '',
            position: Number(link.dataset.position || 0)
          });
        });
      });
      panel.querySelectorAll('[data-concierge-quick-add]').forEach((button) => {
        button.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          if (!event.repeat && button.getAttribute('aria-busy') !== 'true' && !button.hasAttribute('disabled')) button.click();
        });
        button.addEventListener('click', (event) => {
          if (button.getAttribute('aria-busy') === 'true' || button.hasAttribute('disabled')) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        }, true);
        button.addEventListener('click', () => {
          if (button.getAttribute('aria-busy') === 'true') return;
          const detail = {
            journey: context,
            product_handle: button.dataset.productHandle || '',
            variant_id: button.dataset.variantId || '',
            position: Number(button.dataset.position || 0),
            source_path: window.location.pathname
          };
          pendingQuickAdd = { button, detail, startedAt: Date.now() };
          button.setAttribute('aria-busy', 'true');
          button.dataset.loading = 'true';
          emit('smart_concierge_quick_add_clicked', detail);
        });
      });
      panel.querySelectorAll('[data-concierge-save]').forEach((button) => {
        button.addEventListener('click', () => {
          const handle = button.dataset.productHandle || '';
          const alreadySaved = savedHandles.includes(handle);
          if (alreadySaved) removeSavedHandle(handle, context);
          else saveHandle(handle, context);
          if (context === 'saved') return renderSaved();
          panel.querySelectorAll(`[data-concierge-save][data-product-handle="${handle}"]`).forEach((item) => {
            const nowSaved = savedHandles.includes(handle);
            item.setAttribute('aria-pressed', String(nowSaved));
            item.textContent = `♡ ${nowSaved ? strings.saved : strings.save}`;
          });
        });
      });
      emit('smart_concierge_completed', {
        journey: context,
        answers: { ...state.answers },
        result_handles: items.map((item) => item.handle)
      });
    };

    const renderResults = () => {
      const { results, relaxed } = rankProducts();
      panel.innerHTML = `
        <div class="waiiqi-concierge__results" aria-live="polite">
          <div class="waiiqi-concierge__results-heading">
            <span class="waiiqi-concierge__eyebrow">${escapeHtml(strings.best)}</span>
            <h3>${escapeHtml(strings.results)}</h3>
            <p>${escapeHtml(relaxed ? strings.noMatches : strings.resultsCopy)}</p>
          </div>
          <div class="waiiqi-concierge__product-grid">${results.map((item, index) => productCard(item, index)).join('')}</div>
        </div>
      `;
      footer.hidden = false;
      backButton.disabled = false;
      bindResultLinks(state.journey, results);
    };

    const renderCompare = () => {
      const handles = current ? [current.handle, ...(current.alternatives || [])] : [];
      const items = handles.map((handle) => productByHandle.get(handle)).filter((item) => item?.available && !item.giftCard).slice(0, 3);
      if (!items.length) {
        state.journey = 'find';
        state.step = 0;
        renderJourneyStep();
        return;
      }
      panel.innerHTML = `
        <div class="waiiqi-concierge__results" aria-live="polite">
          <div class="waiiqi-concierge__results-heading">
            <span class="waiiqi-concierge__eyebrow">${escapeHtml(strings.compare)}</span>
            <h3>${escapeHtml(strings.results)}</h3>
            <p>${escapeHtml(strings.resultsCopy)}</p>
          </div>
          <div class="waiiqi-concierge__product-grid">${items.map((item, index) => productCard(item, index, 'compare')).join('')}</div>
        </div>
      `;
      footer.hidden = false;
      backButton.disabled = true;
      bindResultLinks('compare', items);
    };

    const localePrefix = (() => {
      const match = window.location.pathname.match(/^\/(fr|es|de|it)(?:\/|$)/);
      return match ? `/${match[1]}` : '';
    })();

    const renderShipping = () => {
      panel.innerHTML = `
        <div class="waiiqi-concierge__info" aria-live="polite">
          <span class="waiiqi-concierge__info-icon" aria-hidden="true">↗</span>
          <h3>${escapeHtml(strings.shippingTitle)}</h3>
          <ul>
            <li>${escapeHtml(strings.shippingBody)}</li>
            <li>${escapeHtml(strings.returnsBody)}</li>
            <li>${escapeHtml(strings.dispatchBody)}</li>
          </ul>
          <div class="waiiqi-concierge__policy-links">
            <a href="${localePrefix}/policies/shipping-policy">${escapeHtml(strings.shippingPolicy)} →</a>
            <a href="${localePrefix}/policies/refund-policy">${escapeHtml(strings.returnPolicy)} →</a>
          </div>
        </div>
      `;
      footer.hidden = false;
      backButton.disabled = true;
      emit('smart_concierge_shipping_viewed');
    };

    const renderDigital = () => {
      if (!digital) return renderHome();
      panel.innerHTML = `
        <div class="waiiqi-concierge__results" aria-live="polite">
          <div class="waiiqi-concierge__results-heading">
            <span class="waiiqi-concierge__eyebrow">${escapeHtml(strings.digital)}</span>
            <h3>${escapeHtml(digital.title)}</h3>
            <p>${escapeHtml(strings.digitalReason)}</p>
          </div>
          <div class="waiiqi-concierge__product-grid waiiqi-concierge__product-grid--single">${productCard(digital, 0, 'digital')}</div>
        </div>
      `;
      footer.hidden = false;
      backButton.disabled = true;
      bindResultLinks('digital', [digital]);
    };

    const profileCard = () => `<section class="waiiqi-wave-profile-card"><h3>${escapeHtml(strings.avatarLabel)}</h3><p>${escapeHtml(storageAvailable ? strings.profileCopy : strings.storageUnavailable)}</p><div class="waiiqi-wave-profile-card__choices" role="group" aria-label="${escapeHtml(strings.avatarLabel)}">${Object.entries(avatars).map(([key,icon]) => `<button type="button" data-waiiqi-avatar-choice="${key}" aria-pressed="${avatar===key}"><span aria-hidden="true">${icon}</span>${escapeHtml(strings[{wave:'avatarWave',sun:'avatarSun',shell:'avatarShell'}[key]])}</button>`).join('')}</div></section>`;
    const renderSaved = () => {
      if (!root.hasAttribute('data-saved-view')) root.querySelector('.waiiqi-concierge__body').scrollTop = 0;
      setSavedPresentation(true);
      const items = savedHandles.map((handle) => productByHandle.get(handle)).filter(Boolean);
      emit('smart_concierge_saved_viewed', { saved_count: items.length, result_handles: items.map((item) => item.handle) });
      if (!items.length) {
        panel.innerHTML = `${profileCard()}
          <div class="waiiqi-concierge__saved-empty" aria-live="polite">
            <span class="waiiqi-concierge__saved-empty-icon" aria-hidden="true">♡</span>
            <h3>${escapeHtml(strings.savedEmpty)}</h3>
            <p>${escapeHtml(strings.savedEmptyCopy)}</p>
            <small>${escapeHtml(storageAvailable ? strings.savedPrivacy : strings.storageUnavailable)}</small>
          </div>
        `;
        footer.hidden = false;
        backButton.disabled = true;
        return;
      }
      panel.innerHTML = `${profileCard()}
        <div class="waiiqi-concierge__results" aria-live="polite">
          <div class="waiiqi-concierge__results-heading">
            <span class="waiiqi-concierge__eyebrow">${escapeHtml(strings.savedJourney)}</span>
            <h3>${escapeHtml(strings.savedTitle)}</h3>
            <p>${escapeHtml(strings.savedCopy)} ${escapeHtml(storageAvailable ? strings.savedPrivacy : strings.storageUnavailable)}</p>
          </div>
          <div class="waiiqi-concierge__product-grid">${items.map((item, index) => productCard(item, index, 'saved')).join('')}</div>
        </div>
      `;
      footer.hidden = false;
      backButton.disabled = true;
      bindResultLinks('saved', items);
    };

    const startJourney = (journey) => {
      setSavedPresentation(false);
      state.journey = journey;
      state.step = 0;
      state.answers = {};
      state.history = [];
      emit('smart_concierge_journey_started', { journey });
      if (journey === 'save-current' && current) {
        saveHandle(current.handle, 'current_product');
        return renderSaved();
      }
      if (journey === 'saved') return renderSaved();
      if (journey === 'compare') return renderCompare();
      if (journey === 'shipping') return renderShipping();
      if (journey === 'digital') return renderDigital();
      renderJourneyStep();
    };

    function renderHome() {
      setSavedPresentation(false);
      state.journey = null;
      state.step = 0;
      state.answers = {};
      state.history = [];
      panel.innerHTML = `
        <div class="waiiqi-concierge__home" data-concierge-home>
          <div class="waiiqi-concierge__journeys">
            ${option({ value: 'find', label: strings.find, icon: '◎' })}
            ${option({ value: 'gift', label: strings.gift, icon: '◇' })}
            ${current && !savedHandles.includes(current.handle) ? option({ value: 'save-current', label: strings.saveCurrent, icon: '♡' }) : ''}
            ${option({ value: 'saved', label: `${strings.savedJourney}${savedHandles.length ? ` · ${savedHandles.length}` : ''}`, icon: '♡', note: strings.savedPrivacy })}
            ${current ? option({ value: 'compare', label: strings.compare, icon: '⇄' }) : ''}
            ${option({ value: 'shipping', label: strings.shipping, icon: '↗' })}
            ${digital ? option({ value: 'digital', label: strings.digital, icon: '✦' }) : ''}
            ${strings.contactUrl ? `<a class="waiiqi-concierge__team-link" data-concierge-team href="${safeUrl(strings.contactUrl)}"><span aria-hidden="true">↗</span><span><strong>${escapeHtml(strings.messageTeam)}</strong><small>${escapeHtml(strings.messageNote)}</small></span></a>` : ''}
          </div>
        </div>
      `;
      footer.hidden = true;
      panel.querySelectorAll('[data-concierge-choice]').forEach((button) => {
        button.addEventListener('click', () => startJourney(button.dataset.conciergeChoice));
      });
    }

    function renderJourneyStep() {
      const steps = stepsForJourney();
      if (state.step >= steps.length) return renderResults();
      renderQuestion(steps[state.step]);
    }

    const open = (trigger = document.activeElement) => {
      window.clearTimeout(closeTimer);
      window.cancelAnimationFrame(openFrame);
      lastFocused = trigger;
      backdrop.hidden = false;
      document.documentElement.classList.add('waiiqi-concierge-open');
      renderHome();
      openFrame = window.requestAnimationFrame(() => {
        backdrop.classList.add('is-open');
        dialog.focus();
      });
      emit('smart_concierge_opened', { source_path: window.location.pathname, current_handle: current?.handle || null });
    };

    const close = (restoreFocus = true) => {
      window.cancelAnimationFrame(openFrame);
      window.clearTimeout(closeTimer);
      backdrop.classList.remove('is-open');
      document.documentElement.classList.remove('waiiqi-concierge-open');
      closeTimer = window.setTimeout(() => { backdrop.hidden = true; }, 180);
      if (restoreFocus && lastFocused?.focus) lastFocused.focus();
      emit('smart_concierge_closed', { journey: state.journey });
    };

    document.addEventListener('ajaxProduct:added', () => {
      if (!pendingQuickAdd) return;
      const { button, detail, startedAt } = pendingQuickAdd;
      button.removeAttribute('aria-busy');
      button.dataset.loading = 'false';
      button.textContent = strings.added;
      emit('smart_concierge_quick_add_succeeded', { ...detail, elapsed_ms: Date.now() - startedAt });
      pendingQuickAdd = null;
      window.setTimeout(() => close(false), 80);
    });

    document.addEventListener('ajaxProduct:error', (event) => {
      if (!pendingQuickAdd) return;
      const { button, detail, startedAt } = pendingQuickAdd;
      button.removeAttribute('aria-busy');
      button.dataset.loading = 'false';
      button.textContent = strings.addError;
      emit('smart_concierge_quick_add_failed', {
        ...detail,
        elapsed_ms: Date.now() - startedAt,
        error: event.detail?.errorMessage || 'unknown'
      });
      pendingQuickAdd = null;
      window.setTimeout(() => { button.textContent = strings.add; }, 2400);
    });

    const trapFocus = (event) => {
      if (event.key === 'Escape') return close();
      if (event.key !== 'Tab') return;
      const focusable = [...dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')].filter((item) => !item.hidden && item.getClientRects().length && getComputedStyle(item).visibility !== 'hidden');
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (!dialog.contains(document.activeElement) || document.activeElement === dialog) {
        event.preventDefault();
        (event.shiftKey ? last : first).focus();
      } else if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    };

    root.addEventListener('click', (event) => {
      const avatarButton = event.target.closest('[data-waiiqi-avatar-choice]');
      if (avatarButton && Object.hasOwn(avatars, avatarButton.dataset.waiiqiAvatarChoice)) {
        avatar = avatarButton.dataset.waiiqiAvatarChoice;
        try { localStorage.setItem(avatarKey, avatar); } catch { storageAvailable = false; }
        updateSavedCount();
        panel.querySelectorAll('[data-waiiqi-avatar-choice]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.waiiqiAvatarChoice === avatar)));
        if (!storageAvailable) panel.querySelector('.waiiqi-wave-profile-card p').textContent = strings.storageUnavailable;
      }
      const opener = event.target.closest('[data-concierge-open]');
      if (opener) open(opener);
      if (event.target.closest('[data-concierge-team]')) {
        const control = nativeChatControl();
        if (!control) return;
        event.preventDefault();
        close(false);
        control.click();
        syncNativeChat();
      }
    });
    document.addEventListener('click', (event) => {
      const saveButton = event.target.closest('[data-waiiqi-save-piece]');
      if (saveButton) {
        const handle = saveButton.dataset.waiiqiSavePiece;
        if (savedHandles.includes(handle)) removeSavedHandle(handle, 'product-page');
        else saveHandle(handle, 'product-page');
        const status = saveButton.closest('[data-waiiqi-saved-actions]')?.querySelector('[data-waiiqi-save-status]');
        if (status) status.textContent = `${savedHandles.includes(handle) ? strings.saved : strings.remove}. ${storageAvailable ? strings.savedPrivacy : strings.storageUnavailable}`;
      }
      const savedButton = event.target.closest('[data-waiiqi-open-saved]');
      if (!savedButton) return;
      const drawer = savedButton.closest('header-drawer');
      const returnFocus = drawer?.querySelector('summary');
      if (drawer) drawer.dispatchEvent(new CustomEvent('drawer:force-close', { bubbles: true }));
      open(returnFocus || savedButton);
      startJourney('saved');
    });
    syncNativeChat();
    window.customElements?.whenDefined('shopify-chat').then(syncNativeChat);
    window.customElements?.whenDefined('shopify-agent-runtime').then(syncNativeChat);
    // A delayed app embed must remain usable without a permanent polling loop.
    [500, 1500, 4000, 10000].forEach((delay) => window.setTimeout(syncNativeChat, delay));
    closeButton.addEventListener('click', close);
    backdrop.addEventListener('click', (event) => { if (event.target === backdrop) close(); });
    document.addEventListener('keydown', (event) => {
      if (document.documentElement.classList.contains('waiiqi-concierge-open')) trapFocus(event);
    });
    restartButton.addEventListener('click', () => {
      emit('smart_concierge_restarted', { journey: state.journey });
      renderHome();
    });
    backButton.addEventListener('click', () => {
      if (!state.journey || state.step <= 0) return renderHome();
      state.step -= 1;
      const removed = state.history.pop();
      if (removed) delete state.answers[removed.key];
      renderJourneyStep();
    });
    window.addEventListener('storage', (event) => {
      if (event.key === avatarKey || event.key === null) {
        try { const value = localStorage.getItem(avatarKey); avatar = Object.hasOwn(avatars, value) ? value : 'wave'; } catch {}
        updateSavedCount();
        if (state.journey === 'saved' && !backdrop.hidden) renderSaved();
      }
      if (event.key !== storageKey && event.key !== null) return;
      savedHandles = loadSavedHandles();
      updateSavedCount();
      if (state.journey === 'saved' && !backdrop.hidden) renderSaved();
    });
    updateSavedCount();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
